import React, { useState } from "react";
import { Link } from "react-router-dom";

const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <nav>
      <div className="mt-3 mx-auto px-7 lg:px-10 font-headerFont font-extrabold">
        <div className="flex justify-between items-center">
          <div>
            <Link to={"/"} className="text-3xl md:text-4xl lg:text-5xl">
              V Y
            </Link>
          </div>

          <div>
            <div
              className="text-xl md:text-2xl lg:text-3xl cursor-pointer"
              onClick={() => setOpen(!open)}
            >
              menu.
            </div>
            {open && (
              <div className="bg-backgroundColor absolute top-13 right-9 md:right-9 lg:right-9 lg:pr-3 py-2">
                <ul className="text-right">
                  <li onClick={() => setOpen(false)} className="link-navbar">
                    <Link to="/">home.</Link>
                  </li>
                  <li onClick={() => setOpen(false)} className="link-navbar">
                    <Link to="/about">about me.</Link>
                  </li>
                  <li onClick={() => setOpen(false)} className="link-navbar">
                    <Link to="/portfolio">work.</Link>
                  </li>
                  <li onClick={() => setOpen(false)} className="link-navbar">
                    <Link to="/contact">contact.</Link>
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Header;
